import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from '../../../../shared/shared.module';
import { DATA_SELECTOR_INJECTION_TOKEN } from '@aiwyn/shared';

export interface ConfirmFlaggedFilesSubmissionData {
  flaggedFilesCount: number;
}

@Component({
  selector: 'app-confirm-flagged-files-submission',
  templateUrl: './confirm-flagged-files-submission.component.html',
  styleUrls: ['./confirm-flagged-files-submission.component.scss'],
  standalone: true,
  imports: [SharedModule],
  providers: [
    {
      provide: DATA_SELECTOR_INJECTION_TOKEN,
      useValue: 'confirm-flagged-files-submission',
    },
  ],
})
export class ConfirmFlaggedFilesSubmissionComponent {
  public dataSelector = inject(DATA_SELECTOR_INJECTION_TOKEN);

  constructor(
    public dialogRef: MatDialogRef<ConfirmFlaggedFilesSubmissionComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmFlaggedFilesSubmissionData,
  ) {}

  /**
   * Close the modal without confirming.
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }

  /**
   * Confirm submission anyway.
   */
  onSubmitAnyway(): void {
    this.dialogRef.close(true);
  }
} 